import React from 'react';
import purchaseCalendarIcon from '../../assets/icons/purchase-calendar.svg';
import { paymentWallTime, PURCHASE_TIME_ZONES } from '../../utils/purchaseTime';

const PaymentDateTime = ({ form, onChange, now = Date.now() }) => {
  const [date = '', time = '00:00'] = form.paymentAt.split('T');
  const [hour, minute] = time.split(':');
  const [maxDate, maxTime] = paymentWallTime(
    new Date(now),
    form.timeZone
  ).split('T');
  const [maxHour, maxMinute] = maxTime.split(':');
  const isToday = date === maxDate;
  const labelDate = new Date(`${date || '2000-01-01'}T12:00:00Z`);
  const update = values => onChange({ ...values, paymentOffset: '' });
  return (
    <div className='sm:col-span-2'>
      <label htmlFor='purchase-payment-date' className='mb-px block text-base'>
        Payment Date &amp; Time <span className='text-red-500'>*</span>
      </label>
      <div className='flex flex-wrap items-center gap-[10px]'>
        <div className='purchase-date relative h-14 w-[184px] rounded-xl border border-[#d7dade] bg-white'>
          <span
            aria-hidden='true'
            className='pointer-events-none absolute inset-0 flex items-center justify-between px-[14px]'
          >
            {date && Number.isFinite(labelDate.getTime())
              ? new Intl.DateTimeFormat('en-GB', {
                  timeZone: 'UTC',
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })
                  .format(labelDate)
                  .replace(' Sept ', ' Sep ')
              : 'Select date'}
            <img src={purchaseCalendarIcon} alt='' className='h-6 w-6' />
          </span>
          <input
            id='purchase-payment-date'
            aria-label='Payment date'
            type='date'
            required
            max={maxDate}
            value={date}
            className='absolute inset-0 h-full w-full rounded-xl bg-white px-3 opacity-0 focus:opacity-100 focus:ring-2 focus:ring-blue-500'
            onChange={event => {
              const nextDate = event.target.value;
              if (nextDate > maxDate) return;
              update({ paymentAt: `${nextDate}T${hour}:${minute}` });
            }}
            onClick={event => {
              try {
                event.currentTarget.showPicker?.();
              } catch (error) {
                /* Native keyboard entry remains available. */
              }
            }}
          />
        </div>
        <div className='flex items-center gap-[10px]'>
          <select
            id='purchase-payment-hour'
            aria-label='Payment hour'
            className='purchase-input w-[83px]'
            value={hour}
            onChange={event =>
              update({ paymentAt: `${date}T${event.target.value}:${minute}` })
            }
          >
            {Array.from({ length: 24 }, (_, i) =>
              String(i).padStart(2, '0')
            ).map(value => (
              <option key={value} disabled={isToday && value > maxHour}>
                {value}
              </option>
            ))}
          </select>
          <span aria-hidden='true' className='text-gray-500'>
            :
          </span>
          <select
            id='purchase-payment-minute'
            aria-label='Payment minute'
            className='purchase-input w-[83px]'
            value={minute}
            onChange={event =>
              update({ paymentAt: `${date}T${hour}:${event.target.value}` })
            }
          >
            {Array.from({ length: 60 }, (_, i) =>
              String(i).padStart(2, '0')
            ).map(value => (
              <option
                key={value}
                disabled={
                  isToday &&
                  (hour > maxHour || (hour === maxHour && value > maxMinute))
                }
              >
                {value}
              </option>
            ))}
          </select>
        </div>
        <select
          id='purchase-timezone'
          aria-label='Payment timezone'
          title={form.timeZone}
          className='purchase-input w-[104px]'
          value={form.timeZone}
          onChange={event => update({ timeZone: event.target.value })}
        >
          {PURCHASE_TIME_ZONES.map(zone => (
            <option key={zone} value={zone} title={zone}>
              {zone}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
export default PaymentDateTime;
